// OpenAPI仕様に準拠した教育背景型
export type EducationalBackground = {
  graduationDate: {
    year: string;
    month: string;
  };
  institution: string; // 教育機関
  major: string; // 専攻
  research: {
    title: string;
    description: string;
  };
  finishedType: FinishedType;
};

// 既存の型定義（互換性のため保持）
export type FinishedType = 'graduation' | 'completion' | '';

const defaultState: EducationalBackground = {
  graduationDate: {
    year: '',
    month: '',
  },
  institution: '',
  major: '',
  research: {
    title: '',
    description: '',
  },
  finishedType: '',
};

export default defaultState;
